import moment from 'moment'
import {API} from '@utils'
import {operatorValues} from '@src/assets/data/constants/operators'

//************************************/
export const customFetchKeysFromQueryStringCallbacks = {
  deepExtractObjectKeyCallback: (props) => {
    const {queryStringKey: index, columsFiltersKeys: keys, queryStringParamObjectKey: key, queryStringParamObjectValue: value, targetKey: k} = props
    if (value.query) {
      return k === key
    }
    const valueKeys = _.map(value, (v, k) => `${key}.${k}`)
    return _.includes(valueKeys, k)
  }
}
//************************************/
const _normalizeBooleanString = (v) => {
  if (_.isString(v)) {
    const s = v.toLowerCase()
    if (_.includes(['true', 'false'], s)) return s
  }
  return 'false'
}
const _validateAdvancedFilterValue = (obj, column) => {
  if (
    !_.isObject(obj) || 
    !_.every(obj, (v, key) => _.includes(['query', 'entity', 'dynamic_filter'], key))
  ) return false
  const entity = column?.filter?.advanced?.entity === obj.entity ? obj.entity : null
  const query = _normalizeBooleanString(obj.query)
  const dynamicFilter = _.isArray(obj.dynamic_filter)
    ? _.compact(
        _.map(obj.dynamic_filter, (item) => {
          if (
            !_.isObject(item) ||
            !_.every(item, (v, key) => _.includes(['key', 'operator', 'value', 'not'], key))
          ) return null
          const key = item.key 
          const operator = _.includes(operatorValues, item.operator) ? item.operator : null
          const value = _.isArray(item.value) || _.isString(item.value) ? item.value : null
          const not = _normalizeBooleanString(item.not)
          if (!key || !operator || _.isNil(value)) return null
          return { key, operator, value, not }
        })
      )
    : []
  if (query !== 'true' || !entity || dynamicFilter.length === 0) return null
  return { query, entity, dynamic_filter: dynamicFilter }
}
//************************************/
export const getFilterSelectors = ({ columns, join = false }) => {
  const filteredCol = _.filter(columns, (column) => {
    return column?.filter?.enabled
  })
  const selectors = _.map(filteredCol, item => item.selector)
  return join ? _.join(selectors, ',') : selectors
}
//************************************/
export const validateFilters = (columns, filter) => {
  const validateParams = {}
  const validateCallback = (value, c) => {
    switch (c.filter.type) {
      case "dateRange": {
        const invalidDateRange = _.filter(value, d => {
          return !(d && moment(d).isValid())
        })
        if (invalidDateRange.length > 0 || value.length < 2) {
          return false
        } else {
          return true
        }
      }; break
      default: {
        return true
      }
    }
  }
  const validateValue = ({ filterValue, filterIndex }) => {
    const column = _.find(columns, (column) => column.selector === filterIndex)
    if (validateCallback(filterValue, column)) {
      validateParams[filterIndex] = filterValue
    } else {
      validateParams[filterIndex] = null
    }
  }
  const validateObject = ({ filterValue, filterIndex }) => {
    if (filterValue.query) {
      const column = _.find(columns, (column) => column.selector === `${filterIndex}`)
      const _filterValue = _validateAdvancedFilterValue(filterValue, column)
      validateParams[filterIndex] = _filterValue ? _filterValue : null
    } else {
      const valueKeys = _.map(filterValue, (value, key) => {
        const column = _.find(columns, (column) => column.selector === `${filterIndex}.${key}`)
        if (validateCallback(value, column)) {
          validateParams[filterIndex] = { ...validateParams[filterIndex], [key]: value }
        } 
        if (!_.pickBy(validateParams[filterIndex], v => v !== null)) {
          validateParams[filterIndex] = null
        }
      })
    }
  }
  _.map(filter, (filterValue, filterIndex) => {
    if (_.isArray(filterValue)) {
      validateValue({ filterValue, filterIndex })
    } else if (_.isObject(filterValue)) {
      validateObject({ filterValue, filterIndex })
    } else {
      validateValue({ filterValue, filterIndex })
    }
  })
  return _.pickBy(validateParams, v => v !== null)
}
//************************************/
export const validateLimit = (limitList, limit, defaultLimit) => {
  try {
    return _.includes(limitList, _.toNumber(limit)) ? limit : defaultLimit
  } catch {
    return defaultLimit
  }
}
//************************************/
export const asyncSlelectLoadOptions = async (remoteUrl, data, formatter) => {
  const { data: _data } =  await API.get(remoteUrl, {
    params: { limit: 20, ...data }
  })
  const result = _.map(_data, (v, k) => {
    return formatter ? formatter(v) : {value: v.id, label: v.name}
  })
  return result
}
//************************************/
export const showHideDynamicFields = (key, value, options, args) => {
  const [dynamicFieldsVisibility, setDynamicFieldsVisibility] = args?.dynamicFieldsVisibilityState
  const resolve = args?.resolveDynamicFieldsVisibility
  const data = []
  const _options = !_.isNil(options) ? (_.isArray(options) ? options : [options]) : []
  if (_.includes(value, '.')) {
    _.forEach(_options, (option, index) => {
      _.forEach(_.split(value, '.'), (selectorFragment) => {
        const v = data[index] ?? option
        if (_.isArray(v)) {
          data[index] = _.map(v, item => item[selectorFragment])
        } else {
          data[index] = v[selectorFragment]
        }
      }) 
    })
  } else {
    _.forEach(_options, (option, index) => {
      if (_.isArray(option)) {
        data[index] = _.map(option, item => item[value])
      } else {
        data[index] = option[value]
      }
    })
  }
  const _data = _.size(data) > 0 ? _.size(_.flatten(data)) === 0 ? false : _.flatten(data) : _.flatten(data)
  const _dynamicFieldsVisibility = { ...dynamicFieldsVisibility, [key]: _data }
  setDynamicFieldsVisibility(_dynamicFieldsVisibility)
  resolve({ key, dynamicFieldsVisibility: _dynamicFieldsVisibility })
}
//************************************/
export const calculateMinWidth = ({ selector, width, ...column }, name, minWidth) => {
  return {}
  
  if (!name || width) return {}

  const fixedCharWidth = 8.5 // 7.5 is the width and + 4.5 is the padding
  const fixedMinWidth = 0
  const fixedSpaces = 50

  const _minWidth = minWidth ? parseInt(_.replace(minWidth, 'px', '')) : fixedMinWidth
  const _nameWidth = name ? parseInt(name.length * fixedCharWidth) : 0
  if (_minWidth === 0 && _nameWidth === 0) {
    return {}
  }
  if (_nameWidth > _minWidth) {
    return { minWidth: `${_nameWidth + fixedSpaces}px` }
  }
  return { minWidth: `${_minWidth + fixedSpaces}px` }
}